import React from 'react'
import { RHFInputField } from '@/components/molecules/rhf-input-field'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { NewReservationInput } from '@/models/space-manager'
import { css } from '@emotion/core'

interface CustomerInfoInputsProps {
  useFormReturn: UseFormReturn<NewReservationInput>
}
export const CustomerInfoInputs: React.FC<CustomerInfoInputsProps> = ({ useFormReturn }) => {
  const { t } = useTranslation()
  const { control } = useFormReturn
  return (
    <div>
      <RHFInputField
        rules={{ required: t('Required field has not been entered') }}
        required={true}
        marginBottom={24}
        label={t('Full name')}
        placeholder={t('John Doe')}
        name="newReservation.name"
        control={control}
      />

      <RHFInputField
        marginBottom={24}
        label={t('Furigana')}
        placeholder={'ヤマダ タロウ'}
        name="newReservation.nameKana"
        control={control}
      />

      <RHFInputField
        rules={{
          pattern: {
            value: /^[0-9]+$/,
            message: t('Please enter numbers only, without symbols or spaces'),
          },
        }}
        marginBottom={24}
        label={t('Phone number')}
        placeholder="08012345678"
        name="newReservation.tel"
        control={control}
      />

      <RHFInputField
        rules={{
          pattern: {
            value:
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: t('Email invalid'),
          },
        }}
        marginBottom={24}
        label={
          <>
            {t('Email address')}
            <div>{t('※Please make sure to fill in the space for smart key use')}</div>
          </>
        }
        placeholder="aipass@aipass.jp"
        name="newReservation.email"
        control={control}
        customStyle={css({
          '.__label': { alignItems: 'center', '>div': { fontSize: 10 } },
        })}
      />

      <RHFInputField marginBottom={24} label={t('Address')} placeholder={t('Address')} name="newReservation.address" control={control} />
    </div>
  )
}
